$(document).on('change', '#shipOrgChecked1', function() {
  if ($(this).is(':checked')) {
    $('#shippingOrganization .ph-forminput').val('');
    $('#shippingOrganization .ph-register__emptyvalue').text('');
    $('#shippingOrganization .ph-signup__error').removeClass('form_field_error ph-form_field_error');
  }
});

$(document).on('blur', '#emailAddress', function() {
  var emailInputId = $(this).attr('id');
  var emailValue = $('#emailAddress input').val();

  ACC.registerPage.isEmptyValue(emailInputId);

  if (ACC.validation.email(emailValue)) {
    $('#emailAddress').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $('#emailAddress').find('.ph-register__emptyvalue').text($('#emailAddress').attr('data-emptyContent'));
  }

  if ($(this).hasClass('anonymoussignup__email')) {
    ACC.anonymouscheckout.emailFieldCheck(true);
  }
});

$(document).on('blur', '#ph-siret', function() {
  var siretInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(siretInputId);
});

$(document).on('blur', '#ph-mednumber', function() {
  if ($(this).attr('data-is-mandatory') === 'true') {
    var medregisterInputId = $(this).attr('id');

    ACC.registerPage.isEmptyValue(medregisterInputId);
  }
});

$(document).on('blur', '#ph-commnumber', function() {
  if ($(this).attr('data-is-mandatory') === 'true') {
    var chamberNumberInputId = $(this).attr('id');

    ACC.registerPage.isEmptyValue(chamberNumberInputId);
  }
});

$(document).on('blur', '#ph-bignumber', function() {
  if ($(this).attr('data-is-mandatory') === 'true') {
    var bignumberInputId = $(this).attr('id');

    ACC.registerPage.isEmptyValue(bignumberInputId);
  }
});

$(document).on('blur', '#ph-vatregistrationNumber', function() {
  if ($(this).attr('data-is-mandatory') === 'true') {
    var vatregistrationInputId = $(this).attr('id');

    ACC.registerPage.isEmptyValue(vatregistrationInputId);
  }
});

$(document).on('blur', '#ph-custAccountNumber', function() {
  var cusAccountInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(cusAccountInputId);
});


$(document).on('blur', '#ph-companyName', function() {
  var companyNameInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(companyNameInputId);
});

$(document).on('blur', '#ph-orgType, #ph-buyingPreference', function() {
  var orgNameInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(orgNameInputId);
});

$(document).on('change', '#ph-orgType, #ph-buyingPreference', function() {
  var orgNameInputId = $(this).attr('id');

  ACC.registerPage.onChangeSelectbox(orgNameInputId);
});

$(document).on('blur', '#ph-firstName', function() {
  var firstnameInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(firstnameInputId);
});

$(document).on('blur', '#ph-lastName', function() {
  var lastnameInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(lastnameInputId);
});

$(document).on('blur', '#ph-phoneNumber', function() {
  var phoneNumberInputId = $(this).attr('id');
  var numbervalidate = $('#ph-phoneNumber input').val();

  ACC.registerPage.isEmptyValue(phoneNumberInputId);

  if (ACC.validation.phoneNumber(numbervalidate)) {
    $('#ph-phoneNumber').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $('#ph-phoneNumber').find('.ph-register__emptyvalue').text($('#ph-phoneNumber').attr('data-emptyContent'));
  }
});

$(document).on('blur', '#ph-userTitle', function() {
  var userTitleInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(userTitleInputId);
});

$(document).on('change', '#ph-userTitle', function() {
  var userTitleInputId = $(this).attr('id');

  ACC.registerPage.onChangeSelectbox(userTitleInputId);
});

$(document).on('blur', '#ph-companyAddressPrimary', function() {
  var companyAddInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(companyAddInputId);
});

$(document).on('blur', '#stateUS, #billOrgStateLabel, #shipOrgStateLabel, #physicianStateContainer', function() {
  var stateusInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(stateusInputId);
});

$(document).on('change', '#stateUS, #billOrgStateLabel, #shipOrgStateLabel, #physicianStateContainer', function() {
  var stateusInputId = $(this).attr('id');

  ACC.registerPage.onChangeSelectbox(stateusInputId);
});

$(document).on('blur', '#stateOther', function() {
  var stateotherInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(stateotherInputId);
});
$(document).on('change', '#stateOther', function() {
  var stateotherInputId = $(this).attr('id');

  ACC.registerPage.onChangeSelectbox(stateotherInputId);
});

$(document).on('blur', '#ph-addressLine1', function() {
  var addressoneInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(addressoneInputId);
});

$(document).on('blur', '#ph-postalCode', function() {
  var postalCodeInputId = $(this).attr('id');
  var postalcodeValue = $('#ph-postalCode input').val().trim();
  var selectId = '#organisationCountry';

  ACC.registerPage.isEmptyValue(postalCodeInputId);

  if (postalcodeValue !== '' && ACC.validation.postalCode(postalcodeValue, selectId)) {
    $('#ph-postalCode').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $('#ph-postalCode').find('.ph-register__emptyvalue').text($('#ph-postalCode').attr(ACC.registerPage.datawrongcontent));
  }

  $('#ph-postalCode input').val(postalcodeValue);
});

$(document).on('blur', '#ph-city', function() {
  var cityInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(cityInputId);
});

$(document).on('blur', '#billOrgNameLabel', function() {
  var billOrgNameLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(billOrgNameLabelInputId);
});

$(document).on('blur', '#billOrgAddressLabel', function() {
  var billOrgAddressLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(billOrgAddressLabelInputId);
});

$(document).on('blur', '#billOrgCityLabel', function() {
  var billOrgCityLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(billOrgCityLabelInputId);
});

$(document).on('blur', '#billOrgPostCodeLabel', function() {
  var billOrgPostCodeLabelInputId = $(this).attr('id');
  var postalcodeValue = $('#billOrgPostCodeLabel input').val();
  var selectId = '#billOrgCountry';

  ACC.registerPage.isEmptyValue(billOrgPostCodeLabelInputId);

  if (postalcodeValue !== '' && ACC.validation.postalCode(postalcodeValue, selectId)) {
    $('#billOrgPostCodeLabel').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $('#billOrgPostCodeLabel').find('.ph-register__emptyvalue').text($('#billOrgPostCodeLabel').attr(ACC.registerPage.datawrongcontent));
  }
});

$(document).on('blur', '#shipOrgNameLabel', function() {
  var shipOrgNameLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(shipOrgNameLabelInputId);
});

$(document).on('blur', '#shipOrgAddressLabel', function() {
  var shipOrgAddressLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(shipOrgAddressLabelInputId);
});

$(document).on('blur', '#shipOrgCityLabel', function() {
  var shipOrgCityLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(shipOrgCityLabelInputId);
});

$(document).on('blur', '#shipOrgPostCodeLabel', function() {
  var shipOrgPostCodeLabelInputId = $(this).attr('id');
  var postalcodeValue = $('#shipOrgPostCodeLabel input').val();
  var selectId = '#shipOrgCountry';

  ACC.registerPage.isEmptyValue(shipOrgPostCodeLabelInputId);

  if (postalcodeValue !== '' && ACC.validation.postalCode(postalcodeValue, selectId)) {
    $('#shipOrgPostCodeLabel').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $('#shipOrgPostCodeLabel').find('.ph-register__emptyvalue').text($('#shipOrgPostCodeLabel').attr(ACC.registerPage.datawrongcontent));
  }
});

$(document).on('blur', '#physicianFirstName', function() {
  var physfirstnameLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(physfirstnameLabelInputId);
});

$(document).on('blur', '#physicianLastName', function() {
  var physlastnameLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(physlastnameLabelInputId);
});

$(document).on('blur', '#physicianProfTitle', function() {
  var physprofLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(physprofLabelInputId);
});


$(document).on('blur', '#physicianBusinessPhone', function() {
  var physbsphnLabelInputId = $(this).attr('id');
  var numbervalidate = $('#physicianBusinessPhone input').val();

  ACC.registerPage.isEmptyValue(physbsphnLabelInputId);

  if (ACC.validation.phoneNumber(numbervalidate)) {
    $('#physicianBusinessPhone').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $('#physicianBusinessPhone').find('.ph-register__emptyvalue').text($('#physicianBusinessPhone').attr('data-emptyContent'));
  }
});

$(document).on('blur', '#physicianAddress', function() {
  var physaddLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(physaddLabelInputId);
});

$(document).on('blur', '#physicianCity', function() {
  var physcityLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(physcityLabelInputId);
});

$(document).on('blur', '#physicianState', function() {
  var physstateLabelInputId = $(this).attr('id');

  ACC.registerPage.isEmptyValue(physstateLabelInputId);
});

$(document).on('change', '#physicianState', function() {
  var physstateLabelInputId = $(this).attr('id');

  ACC.registerPage.onChangeSelectbox(physstateLabelInputId);
});

$(document).on('blur', '#physicianPostalCode', function() {
  var physpostlcdLabelInputId = $(this).attr('id');
  var postalcodeValue = $('#physicianPostalCode input').val();
  var selectId = '#physicianCountry';

  ACC.registerPage.isEmptyValue(physpostlcdLabelInputId);

  if (postalcodeValue !== '' && ACC.validation.postalCode(postalcodeValue, selectId)) {
    $('#physicianPostalCode').find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
    $('#physicianPostalCode').find('.ph-register__emptyvalue').text($('#physicianPostalCode').attr(ACC.registerPage.datawrongcontent));
  }
});

ACC.registerPage = {

  datawrongcontent: 'data-wrongContent',

  additionalclickshippingAdd: function(addressCount) {
    $(document).on('blur', '#shipOrgNameLabel' + addressCount, function() {
      var addnewshipOrgNameInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(addnewshipOrgNameInputId);
    });
    $(document).on('blur', '#shipOrgAddressLabel' + addressCount, function() {
      var addnewshipaddInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(addnewshipaddInputId);
    });
    $(document).on('blur', '#shipOrgCityLabel' + addressCount, function() {
      var addnewshipcityInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(addnewshipcityInputId);
    });
    $(document).on('blur', '#shipOrgStateLabel' + addressCount, function() {
      var addnewshipstateInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(addnewshipstateInputId);
    });
    $(document).on('blur', '#shipOrgPostCodeLabel' + addressCount, function() {
      var addnewshipcodeInputId = $(this).attr('id');
      var postalcodeValue = $('#shipOrgPostCodeLabel' + addressCount + ' input').val();
      var selectId = '#shipOrgCountry' + addressCount;

      ACC.registerPage.isEmptyValue(addnewshipcodeInputId);

      if (postalcodeValue !== '' && ACC.validation.postalCode(postalcodeValue, selectId)) {
        $('#shipOrgPostCodeLabel' + addressCount).find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
        $('#shipOrgPostCodeLabel' + addressCount).find('.ph-register__emptyvalue').text($('#shipOrgPostCodeLabel' + addressCount).attr(ACC.registerPage.datawrongcontent));
      }
    });
  },

  additionalclickbillingAdd: function(addressCount) {
    $(document).on('blur', '#billOrgNameLabel' + addressCount, function() {
      var addnewbillOrgNameInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(addnewbillOrgNameInputId);
    });
    $(document).on('blur', '#billOrgAddressLabel' + addressCount, function() {
      var addnewbilladdInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(addnewbilladdInputId);
    });
    $(document).on('blur', '#billOrgCityLabel' + addressCount, function() {
      var addnewbillcityInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(addnewbillcityInputId);
    });
    $(document).on('blur', '#billOrgStateLabel' + addressCount, function() {
      var addnewbillstateInputId = $(this).attr('id');

      ACC.registerPage.isEmptyValue(addnewbillstateInputId);
    });
    $(document).on('blur', '#billOrgPostCodeLabel' + addressCount, function() {
      var addnewbillCodeInputId = $(this).attr('id');
      var postalcodeValue = $('#billOrgPostCodeLabel' + addressCount + ' input').val();
      var selectId = '#billOrgCountry' + addressCount;

      ACC.registerPage.isEmptyValue(addnewbillCodeInputId);

      if (postalcodeValue !== '' && ACC.validation.postalCode(postalcodeValue, selectId)) {
        $('#billOrgPostCodeLabel' + addressCount).find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
        $('#billOrgPostCodeLabel' + addressCount).find('.ph-register__emptyvalue').text($('#billOrgPostCodeLabel' + addressCount).attr(ACC.registerPage.datawrongcontent));
      }
    });
  },

  isEmptyValue: function(inputId) {
    var errormsgValue = $('#' + inputId).attr('data-emptyContent'),
        inputValue = '';

    if ($('#' + inputId).find('.form_field-input input').length > 0) {
      inputValue = $('#' + inputId).find('input').val();
    } else if ($('#' + inputId).find('.form_field-input select').length > 0) {
      inputValue = $('#' + inputId).find('option:selected').val();
    } else if ($('select#' + inputId).length > 0) {
      inputValue = $('select#' + inputId).val();
    }

    if (!inputValue || inputValue === '') {
      $('#' + inputId).find('.ph-signup__error').addClass('form_field_error ph-form_field_error');
      $('#' + inputId).find('.ph-register__emptyvalue').text(errormsgValue);
    } else {
      $('#' + inputId).find('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
      $('#' + inputId).find('.ph-register__emptyvalue').text('');
    }
  },

  onChangeSelectbox: function(inputId) {
    var inputValue = $('#' + inputId).find('option:selected').val();

    if (inputValue !== '' || inputValue !== null || inputValue !== 'undefined') {
      $('#' + inputId).find('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
      $('#' + inputId).find('.ph-register__emptyvalue').text('');
      $(document).off('blur', '#' + inputId);
    }
  },
  identifierNumberValidation: function() {
    $(document).on('keyup', '#registerIdentifierNumber', function() {
      $(this).val($(this).val().replace(/[^0-9]/g, ''));
    });
    $(document).on('blur', '#registerIdentifierNumber', function() {
      var $currentNode = $(this);

      if ($.trim($(this).val()) !== '' && !ACC.anonymouscheckout.isTenDigit($(this).val())) {
        var errormsgValue = $currentNode.parents('.ph-signup__error').parent().attr('data-invalidnpi');

        $currentNode.parents('.ph-signup__error').addClass('form_field_error ph-form_field_error');
        $currentNode.parents('.ph-signup__error').find('.ph-register__emptyvalue').text(errormsgValue);
      } else {
        $currentNode.parents('.ph-signup__error').removeClass('form_field_error ph-form_field_error');
        $currentNode.parents('.ph-signup__error').find('.ph-register__emptyvalue').text('');
      }
    });
  },
  showErrorMessage: function() {
    $('#ph-formateErrorMessage').removeClass('hidden');
    $('#ph-formateErrorMessage').show();
  },
  removeErrorMessage: function() {
    $('#ph-formateErrorMessage').addClass('hidden');
    $('#ph-formateErrorMessage').hide();
  },
  checksizeLimit: function(fileSize, allowedTotalSize, fileInput) {
    if (fileSize > allowedTotalSize) {
      fileInput.value = '';
      $('.ph-fileSizeError').removeClass('hidden');
    } else {
      $('.ph-fileSizeError').addClass('hidden');
    }
  },
  checkvalidExe: function(checkvalidExtension) {
    if (checkvalidExtension === false) {
      ACC.registerPage.showErrorMessage();
    } else {
      ACC.registerPage.removeErrorMessage();
    }
  },
  checkvalidnumFiles: function(validNumOfFiles) {
    if ($('#fileuploadmultiple').get(0).files.length > validNumOfFiles) {
      $('.ph-numfileserror').removeClass('hidden');
    } else {
      $('.ph-numfileserror').addClass('hidden');
    }
  },

  calculateFileMb: function() {
    var fileSize = 0;
    var fileInputLength = document.getElementById('fileuploadmultiple').files.length;


    if (fileInputLength > 0) {
      for (var i = 0; i < fileInputLength;) {
        fileSize = fileSize + document.getElementById('fileuploadmultiple').files[i].size;
        i = i + 1;
      }
    }

    return fileSize;
  },
  showHideUploadDocs: function() {
    ACC.fileupload.showElement($('.ph-uploading-section'), true);
    ACC.fileupload.hideElement($('.ph-upload-section'), true);
    ACC.fileupload.hideElement($('.ph-status-message,.ph-remove-upload'));
    ACC.fileupload.showElement($('.ph-progress-status,.ph-cancel-upload,.ph-progress'));
  },
  checkvalidFileExe: function() {
    var validFileExtension = $('#validFileExtension').val();
    var inputFilename = '';
    var validFileExtensionArray = validFileExtension.split(',');
    var faildextensionCount = 0;
    var extensionCheckregex = new RegExp('([a-zA-Z0-9_\\.:])+(' + validFileExtensionArray.join('|') + ')$', 'i');

    if (document.getElementById('fileuploadmultiple').files.length > 0) {
      for (var i = 0; i < document.getElementById('fileuploadmultiple').files.length;) {
        inputFilename = document.getElementById('fileuploadmultiple').files[i].name;

        if (!extensionCheckregex.test(inputFilename.toLowerCase())) {
          faildextensionCount = faildextensionCount + 1;
        }

        i = i + 1;
      }
    }

    if (faildextensionCount >= 1) {
      return false;
    }

    return true;
  },
  uplodMultipleDocButton: function(obj) {
    var fileSize = 0;

    ACC.registerPage.showHideUploadDocs();

    var validNumOfFiles = $('#validNoOfFiles').val();
    var validFileSize = $('#validFileSize').val();

    fileSize = ACC.registerPage.calculateFileMb();

    if (document.getElementById('fileuploadmultiple').files.length <= validNumOfFiles) {
      if (ACC.registerPage.checkvalidFileExe() === true) {
        // Var fileSizeInMb = Number(parseFloat(fileSize / 1024 / 1000).toFixed(2));

        if (fileSize <= validFileSize) {
          var filexhr = $.ajax({
            xhr: function() {
              var xhr = new window.XMLHttpRequest();

              xhr.upload.addEventListener('progress', function(e) {
                if (e.lengthComputable) {
                  var percent = Math.round((e.loaded / e.total) * 100);

                  $('.ph-progress-bar').attr('aria-valuenow', percent).css('width', percent + '%');
                  $('.ph-progress-percentage').text(percent + '%');
                }
              });

              return xhr;
            },
            url: obj.path,
            type: 'post',
            data: obj.formData,
            contentType: false,
            processData: false,
            enctype: 'multipart/form-data',
            success: function() {
              var successMsg = $('.ph-status-message').attr('data-successMsg');

              $('.ph-status-message').html(successMsg);
              ACC.fileupload.showElement($('.ph-status-message,.ph-remove-upload'));
              ACC.fileupload.hideElement($('.ph-drop-section,.ph-progress-status,.ph-cancel-upload,.ph-progress,.ph-retry-upload'), true);
            },
            error: function() {
              ACC.fileupload.showError();
            }
          });

          $('.ph-cancel-upload').on('click', function() {
            filexhr.abort();
            ACC.fileupload.resetDiv();
          });
        } else {
          $(obj.fId).val('');
          ACC.registerPage.displayMultipleFileError('data-sizeError');
        }
      } else {
        $(obj.fId).val('');
        ACC.registerPage.displayMultipleFileError('data-wrongFile');
      }
    } else {
      $(obj.fId).val('');
      ACC.registerPage.displayMultipleFileError('data-numFilesError');
    }
  },
  displayMultipleFileError: function(element) {
    $('.ph-status-message').html($('.ph-status-message').attr(element));
    ACC.fileupload.showElement($('.ph-status-message, .ph-progress, .ph-retry-upload'));
    ACC.fileupload.hideElement($('.ph-drop-section,.ph-progress-status,.ph-cancel-upload,.ph-progress,.ph-remove-upload'), true);
  },
  getFileChangeRegister: function(e, fileItem) {
    if ($('.enableRegDocsToggle').html() === 'true') {
      var file = '',
          obj = {},
          resetMsg = $('.ph-file-name').attr('data-default'),
          parentForm = document.getElementById($('.ph-file-input').attr('data-parentForm'));

      obj.formData = new FormData(parentForm);
      obj.path = $('.ph-file-input').attr('data-uploadUrl');
      obj.fId = '.ph-file-input';
      obj.resetMsg = resetMsg;

      if (fileItem && fileItem.length > 0) {
        obj.formData.append('getSpFile', fileItem);
        file = fileItem;
      } else {
        file = e.files[0].name;
      }

      $('.ph-file-name').html(file);
      ACC.registerPage.uplodMultipleDocButton(obj);
    }
  },
  dragdropFunction: function() {
    $('.ph-common-file-upload,.ph-drop-section').on('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      ACC.fileupload.hideElement($('.ph-upload-section,.ph-uploading-section'), true);
      ACC.fileupload.showElement($('.ph-drop-section'), true);
    }).on('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
    }).on('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      ACC.fileupload.showElement($('.ph-uploading-section'), true);
      ACC.fileupload.hideElement($('.ph-upload-section'), true);

      var boxFile = document.querySelector('#fileuploadmultiple');

      boxFile.files = e.originalEvent.dataTransfer.files;
      ACC.registerPage.getFileChangeRegister(boxFile);
    });
  }


};

$(document).ready(function() {
  for (var addressCount = 1; addressCount <= 8; addressCount = addressCount + 1) {
    ACC.registerPage.additionalclickshippingAdd(addressCount);
    ACC.registerPage.additionalclickbillingAdd(addressCount);
  }

  ACC.registerPage.identifierNumberValidation();

  if ($('.enableRegDocsToggle').html() === 'true') {
    var validFileSize = $('#validFileSize').val();

    var fileSizeMb = Number(parseFloat(validFileSize / 1024 / 1000).toFixed(2));

    $('#fileSizeMb').val(fileSizeMb);
  }

  if ($('.ph-common-file-upload').length > 0 && $('.ph-page-register').length > 0) {
    ACC.registerPage.dragdropFunction();
  }
});
